import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-panel-icon',
  templateUrl: './filter-panel-icon.component.html',
  styleUrls: ['./filter-panel-icon.component.scss']
})
export class FilterPanelIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
